/**
 * Cooking icon names — canonical keys used in the asset resolver.
 * Each corresponds to a hand-authored SVG component in ../components/cooking-icons/.
 */
export const COOKING_ICON_NAMES = [
  "chop",
  "stir",
  "boil",
  "roast",
  "peel",
  "season",
  "rest",
  "oven",
  "timer",
] as const;

export type CookingIconName = (typeof COOKING_ICON_NAMES)[number];
